export default __webpack_public_path__ + "static/media/a17.784f9c49.webp";